module.exports = __webpack_public_path__ + "static/media/delivery.041b65b6.svg";